import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../../components/Pagination";
import NoResultsFound from "../../../components/NoResultsFound";
import SearchBar from "../../../components/SearchBar";
import TableSkeleton from "../../../components/Skeleton";
import { getAllLookup } from "../../../redux/features/lookup/lookupService";

const Lookup = () => {

    const dispatch = useDispatch();

    const { isLookupLoading, pageCount, data } = useSelector((state) => state.lookup.allLookup);
    const [skip, setSkip] = useState(0);

    const limit = 25; 
    const [searchQuery, setSearchQuery] = useState('');

    const fetchAllLookups = useCallback(() => {
        dispatch(getAllLookup({
            skip: skip,
            limit,
            search: searchQuery,
        }));
    }, [dispatch, skip, searchQuery]);

    useEffect(() => {
        fetchAllLookups();
    }, [fetchAllLookups]);

  const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    return (
        <div className={`card-section`}>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Lookup List</h1>
                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                </div>
                <div className={`search-card-body`}>
                    {isLookupLoading ?
                        <TableSkeleton columns={["Country", "Region", "City", "Time Zone", "Postal"]} rowCount={10} height={20} />
                        : data.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Country</th>
                                            <th>Region</th>
                                            <th>City</th>
                                            <th>Time Zone</th>
                                            <th>Postal</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {data?.map((lookup) => (
                                            <tr key={lookup.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {lookup.country_name}
                                                </td>
                                                <td>{lookup.region}</td>
                                                <td>{lookup.city}</td>
                                                <td>{lookup.timezone}</td>
                                                <td>{lookup.country_code}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Lookup;